import { render, staticRenderFns } from "./tousu.vue?vue&type=template&id=5d83e5cc&scoped=true&"
import script from "./tousu.vue?vue&type=script&lang=js&"
export * from "./tousu.vue?vue&type=script&lang=js&"
import style0 from "./tousu.vue?vue&type=style&index=0&id=5d83e5cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d83e5cc",
  null
  
)

export default component.exports